import React, { useState } from 'react'
import { FaLightbulb } from 'react-icons/fa'
import '../Tools.css'

const LEDResistorCalculator = () => {
    const [supplyVoltage, setSupplyVoltage] = useState('5')
    const [ledVoltage, setLedVoltage] = useState('2')
    const [ledCurrent, setLedCurrent] = useState('20')
    const [numLeds, setNumLeds] = useState('1')

    const calculateResistor = () => {
        const vs = parseFloat(supplyVoltage)
        const vled = parseFloat(ledVoltage)
        const iled = parseFloat(ledCurrent) / 1000 // Convert mA to A
        const n = parseInt(numLeds)

        if (isNaN(vs) || isNaN(vled) || isNaN(iled) || isNaN(n) || iled === 0) {
            return { resistance: 0, power: 0, valid: false }
        }

        const vr = vs - (vled * n)
        if (vr <= 0) {
            return { resistance: 0, power: 0, valid: false, error: 'Supply voltage too low for LEDs in series' }
        }

        const resistance = vr / iled
        const power = vr * iled

        return { resistance, power, valid: true }
    }

    const result = calculateResistor()

    const getStandardResistor = (value) => {
        const e24Series = [1.0, 1.1, 1.2, 1.3, 1.5, 1.6, 1.8, 2.0, 2.2, 2.4, 2.7, 3.0, 3.3, 3.6, 3.9, 4.3, 4.7, 5.1, 5.6, 6.2, 6.8, 7.5, 8.2, 9.1]
        const multipliers = [1, 10, 100, 1000, 10000, 100000]

        let closest = 0
        let minDiff = Infinity

        for (const mult of multipliers) {
            for (const val of e24Series) {
                const stdVal = val * mult
                const diff = Math.abs(stdVal - value)
                if (diff < minDiff && stdVal >= value) {
                    minDiff = diff
                    closest = stdVal
                }
            }
        }
        return closest
    }

    return (
        <div className="tool-calculator">
            <h3><FaLightbulb /> LED Resistor Calculator</h3>
            <p className="tool-description">Calculate the current-limiting resistor needed for your LED circuit.</p>

            <div className="led-inputs">
                <div className="input-group">
                    <label>Supply Voltage (V)</label>
                    <input
                        type="number"
                        value={supplyVoltage}
                        onChange={(e) => setSupplyVoltage(e.target.value)}
                        placeholder="5"
                    />
                </div>
                <div className="input-group">
                    <label>LED Forward Voltage (V)</label>
                    <input
                        type="number"
                        value={ledVoltage}
                        onChange={(e) => setLedVoltage(e.target.value)}
                        placeholder="2"
                    />
                </div>
                <div className="input-group">
                    <label>LED Current (mA)</label>
                    <input
                        type="number"
                        value={ledCurrent}
                        onChange={(e) => setLedCurrent(e.target.value)}
                        placeholder="20"
                    />
                </div>
                <div className="input-group">
                    <label>Number of LEDs (series)</label>
                    <input
                        type="number"
                        value={numLeds}
                        onChange={(e) => setNumLeds(e.target.value)}
                        placeholder="1"
                        min="1"
                    />
                </div>
            </div>

            {result.valid ? (
                <div className="result-box">
                    <div className="result-row">
                        <span className="result-label">Calculated Resistance:</span>
                        <span className="result-value">{result.resistance.toFixed(2)} &Omega;</span>
                    </div>
                    <div className="result-row">
                        <span className="result-label">Nearest Standard Value (E24):</span>
                        <span className="result-value">{getStandardResistor(result.resistance)} &Omega;</span>
                    </div>
                    <div className="result-row">
                        <span className="result-label">Resistor Power Dissipation:</span>
                        <span className="result-value">{(result.power * 1000).toFixed(2)} mW</span>
                    </div>
                    <div className="result-row">
                        <span className="result-label">Recommended Power Rating:</span>
                        <span className="result-value">{result.power < 0.125 ? '1/8W' : result.power < 0.25 ? '1/4W' : result.power < 0.5 ? '1/2W' : '1W+'}</span>
                    </div>
                </div>
            ) : (
                <div className="result-box error">
                    <span className="result-label">{result.error || 'Please enter valid values'}</span>
                </div>
            )}
        </div>
    )
}

export default LEDResistorCalculator
